/**
 * Simple way to determine mobile browsers. There are more elegant Regex's (http://detectmobilebrowsers.com/)
 * or the USParser lib (https://www.npmjs.com/package/ua-parser-js), but this fits the current use case.
 */
export const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
